import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Phone, EnvelopeSimple, MapPin } from '@phosphor-icons/react';

const Contact = ({ onQuoteClick }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="contact" data-testid="contact-section" className="section-padding bg-secondary-bg" ref={ref}>
      <div className="container-custom">
        {/* Heading + CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="overline mb-4">Get In Touch</p>
          <h2 data-testid="contact-heading"
            className="text-4xl sm:text-5xl font-heading font-light text-heading mb-8">
            Ready to Build?
          </h2>
          <button onClick={onQuoteClick} data-testid="contact-cta-button"
            className="btn-primary text-lg px-10 py-4">
            Get a Free Quote
          </button>
        </motion.div>

        {/* Photo + Contact Details Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Brett & Raya Photo */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="overflow-hidden"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_build-website-154/artifacts/cqr77w6o_Enhance-1775970287447.jpg"
              alt="Brett and Raya Rimmer"
              data-testid="contact-photo"
              className="w-full h-auto object-cover"
            />
            <p className="text-body-muted text-xs mt-3 text-center">Brett & Raya Rimmer — Rimsie Constructions Pty Ltd</p>
          </motion.div>

          {/* Contact Details */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="space-y-8"
          >
            <div className="bg-primary-bg border border-border-subtle p-8">
              <h3 className="text-heading text-xl font-heading mb-6">Contact Details</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 flex-shrink-0">
                    <Phone size={20} className="text-accent" />
                  </div>
                  <div>
                    <p className="text-body-muted text-sm mb-1">Brett Rimmer (Director)</p>
                    <a href="tel:0416283443" data-testid="phone-brett"
                      className="text-heading text-lg hover:text-accent transition-colors">0416 283 443</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 flex-shrink-0">
                    <Phone size={20} className="text-accent" />
                  </div>
                  <div>
                    <p className="text-body-muted text-sm mb-1">Raya Rimmer (Admin)</p>
                    <a href="tel:0414481535" data-testid="phone-raya"
                      className="text-heading text-lg hover:text-accent transition-colors">0414 481 535</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 flex-shrink-0">
                    <EnvelopeSimple size={20} className="text-accent" />
                  </div>
                  <div>
                    <p className="text-body-muted text-sm mb-1">Email</p>
                    <a href="mailto:rimsieconstructions@hotmail.com" data-testid="email-link"
                      className="text-heading hover:text-accent transition-colors break-all">rimsieconstructions@hotmail.com</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 flex-shrink-0">
                    <MapPin size={20} className="text-accent" />
                  </div>
                  <div>
                    <p className="text-body-muted text-sm mb-1">Address</p>
                    <p className="text-heading">16/4 Colony Close<br />Tuggerah NSW 2261</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Click to Call - Mobile */}
            <a href="tel:0416283443" data-testid="click-to-call"
              className="btn-primary w-full flex items-center justify-center gap-3 lg:hidden">
              <Phone size={24} />Call Brett Now
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
